import React from 'react'
import { DataItemRow, Texto } from '@gravitate-js/excalibrr'
import { Col } from 'antd'
import { FormInput } from '../../../_SiteWide/Form/FormInput'

export const DriverContact = ({ driver, editing }) => {
  return (
    <Col span={16} className='right-side'>
      <Texto category='h5'>{`Contact`}</Texto>
      <div className='driver-form-line email pt-3'>
        <DataItemRow label='Work Email' labelSpan={8} valueSpan={16}>
          <FormInput
            initialValue={driver ? <Texto align='right'>{driver.work_email}</Texto> : null}
            type='email'
            editable={editing}
            name='work_email'
            width='100%'
            placeholder='Work Email'
          />
        </DataItemRow>
      </div>
    </Col>
  )
}
